import type { ITabBodyProps } from '../Tab.helpers';

const TabBody = ({ isActive, children, removeDOM }: ITabBodyProps) => {
	if (removeDOM && !isActive) return;

	return <div className={`tab_body${isActive ? ' active' : ''}`}>{children}</div>;
};

export default TabBody;
